import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=58c14ef5&scoped=true&"
import script from "./LicenseCard.vue?vue&type=script&lang=ts&"
export * from "./LicenseCard.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseCard.vue?vue&type=style&index=0&id=58c14ef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c14ef5",
  null
  
)

export default component.exports